import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuListComponent } from './menu-list/menu-list.component';
import { MoleculesModule } from '../molecules/molecules.module';
import { LoginFormComponent } from './login-form/login-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CalendarFilterComponent } from './calendar-filter/calendar-filter.component';
import { DatatableComponent } from './datatable/datatable.component';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CardCamComponent } from './card-cam/card-cam.component';
import { PipesModule } from 'src/shared/pipes/pipes.module';

@NgModule({
  imports: [
    CommonModule,
    MoleculesModule,
    FormsModule,
    MatTableModule,
    MatPaginatorModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatDialogModule,
    MatInputModule,
    TranslateModule,
    MatTooltipModule,
    PipesModule
  ],
  declarations: [
    MenuListComponent,
    LoginFormComponent,
    CalendarFilterComponent,
    DatatableComponent,
    CardCamComponent
  ],
  exports: [
    MoleculesModule,
    MenuListComponent,
    LoginFormComponent,
    CalendarFilterComponent,
    DatatableComponent,
    CardCamComponent
  ],
  providers: [],
})
export class OrganismsModule {}
